
  import {Component, Prop, Vue} from 'vue-property-decorator';
  import {EDITOR_MENUBAR_BTN, EDITOR_MENUBAR_BTN_ACTIVE} from '@/configs/colors';

  @Component
  export default class rteBtn extends Vue {
    // Les props
    @Prop() private is_active!: boolean;
    @Prop() private icon_name!: string;
    @Prop({default: false}) private no_toggle!: boolean;

    // Les propriétés
    private menubar_btn = EDITOR_MENUBAR_BTN;
    private menubar_btn_active = EDITOR_MENUBAR_BTN_ACTIVE;

    // Les propriétés calculées
    private get thecolor() {
      return this.no_toggle ? this.menubar_btn : this.is_active ? this.menubar_btn_active : this.menubar_btn;
    }
    // Les hooks
    // Les méthodes surveillées
    // Les méthodes d'instance
    // Les méthodes statiques
  }
